import autoBind from 'auto-bind';

class TouchClickPolyfill {
  start = {
    x: 0,
    y: 0,
  };

  end = {
    x: 0,
    y: 0,
  };

  constructor() {
    autoBind(this);
    this.addEventListeners();
  }

  onTouchStart(event) {
    this.start.y = event instanceof TouchEvent ? event.touches[0].clientY : event.clientY;
    this.start.x = event instanceof TouchEvent ? event.touches[0].clientX : event.clientX;
  }

  onTouchMove(event) {
    this.end.y = event instanceof TouchEvent ? event.touches[0].clientY : event.clientY;
    this.end.x = event instanceof TouchEvent ? event.touches[0].clientX : event.clientX;
  }

  onTouchEnd(event) {
    this.end.y = event instanceof TouchEvent ? event.changedTouches[0].clientY : event.clientY;
    this.end.x = event instanceof TouchEvent ? event.changedTouches[0].clientX : event.clientX;

    if (JSON.stringify(this.start) !== JSON.stringify(this.end)) return;
    document.body.querySelector('canvas.webgl').dispatchEvent(new PointerEvent('pointermove', { clientX: this.end.x, clientY: this.end.y, bubbles: true }));
    document.body.querySelector('canvas.webgl').dispatchEvent(new MouseEvent('click', { clientX: this.end.x, clientY: this.end.y, bubbles: true }));
  }

  addEventListeners() {
    window.addEventListener('touchstart', this.onTouchStart);
    window.addEventListener('touchmove', this.onTouchMove);
    window.addEventListener('touchend', this.onTouchEnd);
  }
}

export default TouchClickPolyfill;
